import {Action} from '@ngrx/store';
import {Device, GetOrganizationDevicesRequest, PostDeviceBrightnessesRequest, PostDeviceNamesRequest} from '../models/device';
import {ErrorPayload} from '../models/general';

export enum DeviceActionTypes {
  GetOrganizationDevices = '[Device] Get Organization Devices',
  GetOrganizationDevicesComplete = '[Device] Get Organization Devices Complete',
  GetOrganizationDevicesError = '[Device] Get Organization Devices Error',
  PostDeviceNames = '[Device] Post Device Names',
  PostDeviceNamesComplete = '[Device] Post Device Names Complete',
  PostDeviceNamesError = '[Device] Post Device Names Error',
  PostShowDevicesLed = '[Device] Post Show Devices Led',
  PostShowDevicesLedComplete = '[Device] Post Show Devices Led Complete',
  PostShowDevicesLedError = '[Device] Post Show Devices Led Error',
  PostHideDevicesLed = '[Device] Post Hide Devices Led',
  PostHideDevicesLedComplete = '[Device] Post Hide Devices Led Complete',
  PostHideDevicesLedError = '[Device] Post Hide Devices Led Error'
}

export class GetOrganizationDevices implements Action {
  readonly type = DeviceActionTypes.GetOrganizationDevices;

  constructor(public payload: GetOrganizationDevicesRequest) {
  }
}

export class GetOrganizationDevicesComplete implements Action {
  readonly type = DeviceActionTypes.GetOrganizationDevicesComplete;

  constructor(public payload: Device[]) {
  }
}

export class GetOrganizationDevicesError implements Action {
  readonly type = DeviceActionTypes.GetOrganizationDevicesError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostDeviceNames implements Action {
  readonly type = DeviceActionTypes.PostDeviceNames;

  constructor(public payload: PostDeviceNamesRequest) {
  }
}

export class PostDeviceNamesComplete implements Action {
  readonly type = DeviceActionTypes.PostDeviceNamesComplete;
}

export class PostDeviceNamesError implements Action {
  readonly type = DeviceActionTypes.PostDeviceNamesError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostShowDevicesLed implements Action {
  readonly type = DeviceActionTypes.PostShowDevicesLed;

  constructor(public payload: PostDeviceBrightnessesRequest) {
  }
}

export class PostShowDevicesLedComplete implements Action {
  readonly type = DeviceActionTypes.PostShowDevicesLedComplete;
}

export class PostShowDevicesLedError implements Action {
  readonly type = DeviceActionTypes.PostShowDevicesLedError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostHideDevicesLed implements Action {
  readonly type = DeviceActionTypes.PostHideDevicesLed;

  constructor(public payload: PostDeviceBrightnessesRequest) {
  }
}

export class PostHideDevicesLedComplete implements Action {
  readonly type = DeviceActionTypes.PostHideDevicesLedComplete;
}

export class PostHideDevicesLedError implements Action {
  readonly type = DeviceActionTypes.PostHideDevicesLedError;

  constructor(public payload: ErrorPayload) {
  }
}

export type DeviceActions =
  | GetOrganizationDevices
  | GetOrganizationDevicesComplete
  | GetOrganizationDevicesError
  | PostDeviceNames
  | PostDeviceNamesComplete
  | PostDeviceNamesError
  | PostShowDevicesLed
  | PostShowDevicesLedComplete
  | PostShowDevicesLedError
  | PostHideDevicesLed
  | PostHideDevicesLedComplete
  | PostHideDevicesLedError;
